import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Login from "./login";
import HomePage from "./homePage";
import SignUp from "./signUp";
import WeatherSocket from "./WeatherSocket";
import ResetPassword from "./resetPassword";
import App from './App'; 
import { LoadingProvider } from './LoadingContext';
import { injectLoadingHandler } from './api';
import { useLoading } from './LoadingContext';
import React, { useEffect } from "react";
import PrivateRoute from './PrivateRoute';
import { restrictedUsers } from "./restrictedUsers";   

function AppRoutes() {
  const { setLoading } = useLoading();

  useEffect(() => {
    injectLoadingHandler(setLoading);
  }, [setLoading]);

  const user = JSON.parse(localStorage.getItem("user")); 
  const isRestrictedUser = restrictedUsers.includes(user?.email);

  return (
    <>
      <App isRestrictedUser={isRestrictedUser} />  
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/ResetPassword" element={<ResetPassword />} />

        {isRestrictedUser ? (
          <>
            <Route
              path="/HomePage"
              element={
                <PrivateRoute>
                  <HomePage isRestrictedUser={isRestrictedUser} />
                </PrivateRoute>
              }
            />
            <Route path="*" element={<Navigate to="/HomePage" />} />
          </>
        ) : (
          <>
            <Route
              path="/HomePage"
              element={
                <PrivateRoute>
                  <HomePage isRestrictedUser={isRestrictedUser} />
                </PrivateRoute>
              }
            />
            <Route
              path="/WeatherSocket"
              element={
                <PrivateRoute>
                  <WeatherSocket />
                </PrivateRoute>
              }
            />
          </>
        )}
      </Routes>
    </>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <LoadingProvider>
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  </LoadingProvider>
);
